import React, { Component } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { addNotification } from '../../actions/notifications';
import { createUserUpload } from '../../actions/user';

import UploadDriverLicense from './UploadDriverLicense';
import { fetchAccountLocalRestrictions } from '../../actions';
import { ALERT_TYPE, dismissAlert } from '../../actions/alerts';

const INITIAL_FILENAME = 'No file selected';
const MAX_UPLOAD_SIZE = 10485760;
const MAX_UPLOAD_SIZE_MB = 10;
const UPLOAD_TYPE = 1; // DRIVER LICENSE DOCUMENT UPLOAD TYPE


class UploadDriverLicenseContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isComplete: false,
      fileForUpload: undefined,
      fileName: INITIAL_FILENAME,
      fileErrors: [],
      documentType: '',
    };
  }
  onSubmit = async () => {
    const {
      fileForUpload,
      fileErrors,
      documentType,
    } = this.state;
    if (!fileErrors || fileErrors.length === 0) {
      this.setState({
        isLoading: true,
        isComplete: false,
      });
      try {
        await this.props.createUserUpload(
          fileForUpload,
          documentType,
          UPLOAD_TYPE,
        );
        this.setState({
          fileForUpload: null,
          isLoading: false,
          isComplete: true,
        });

        this.props.alerts.forEach((alert) => {
          if (alert.type === ALERT_TYPE.DL_NOT_UPLOADED && alert.visible) {
            this.props.dismissAlert(alert.id);
          }
        });
      } catch (err) {
        if (err.res) {
          const { error } = await err.res.json();
          switch (error.message) {
            case 'request entity too large':
              this.props.addNotification('The selected file is too large.');
              break;
            default:
              this.props.addNotification(`Error response from server: ${
                (error && error.validationErrors &&
                  JSON.stringify(error.validationErrors, null, 2)) ||
                  err.message ||
                  error.message}`);
              break;
          }
        } else {
          this.props.addNotification('Unknown error');
        }
        this.setState({
          isLoading: false,
          isComplete: false,
        });
      }
    }
  }
  onDrop = (acceptedFiles) => {
    if (acceptedFiles[0]) {
      const file = acceptedFiles[0];
      const fileErrors = this.validateFile(file);

      if (fileErrors.length === 0) {
        const reader = new FileReader();
        reader.onload = () => {
          const fileAsB64 = window.btoa(reader.result);
          this.setState({
            isLoading: false,
            fileForUpload: fileAsB64,
          });
        };
        reader.onabort = () => {
          this.setState({
            isLoading: false,
            fileName: INITIAL_FILENAME,
            fileErrors: ['Loading file cancelled.'],
          });
        };
        reader.onerror = () => {
          this.setState({
            isLoading: false,
            fileName: INITIAL_FILENAME,
            fileErrors: ['Unable to read selected file.'],
          });
        };

        reader.readAsBinaryString(file);
      }

      this.setState({
        isLoading: fileErrors && fileErrors.length === 0,
        fileName: file.name,
        fileErrors: fileErrors.length > 0 ? fileErrors : null,
      });
    } else {
      this.props.addNotification('File not found.');
      this.setState({
        fileName: INITIAL_FILENAME,
      });
    }
  }

  getFileExtension = filename => ((filename.lastIndexOf('.') < 1) ? null : filename.split('.').slice(-1)[0]);

  validateFile = (file) => {
    const fileErrors = [];
    if (file.size > MAX_UPLOAD_SIZE) {
      fileErrors.push(`File must be smaller than ${MAX_UPLOAD_SIZE_MB} MB.`);
    }

    if (!file.name.toLowerCase().endsWith('.bmp')
        && !file.name.toLowerCase().endsWith('.jpg')
        && !file.name.toLowerCase().endsWith('.jpeg')
        && !file.name.toLowerCase().endsWith('.png')) {
      fileErrors.push('File must be a .jpg, jpeg, .png, or .bmp.');
    }

    let documentType = 'image/';
    const fileExtension = this.getFileExtension(file.name.toLowerCase());

    switch (fileExtension) {
      case 'bmp':
        documentType += 'bmp';
        break;
      case 'jpg':
        documentType += 'jpg';
        break;
      case 'png':
        documentType += 'png';
        break;
      default:
        documentType = 'image/';
        break;
    }

    this.setState({
      documentType,
    });


    return fileErrors;
  }
  render() {
    const { accountNumber } = this.props;
    const {
      fileName,
      fileErrors,
      isLoading,
      isComplete,
    } = this.state;

    const instructions = 'Drag files into box or click box to select file for upload.';
    return (
      <UploadDriverLicense
        onSubmit={this.onSubmit}
        docTypeOptions={null}
        fileName={fileName}
        fileErrors={fileErrors}
        onDrop={this.onDrop}
        instructions={instructions}
        isLoading={isLoading}
        isComplete={isComplete}
        accountNumber={accountNumber}
      />
    );
  }
}

const mapStateToProps = (state, { match: { params: { userId } } }) => ({
  accountNumber: state.currentAccount,
  userId,
  alerts: get(state, 'alerts', []),
});

const mapDispatchToProps = {
  createUserUpload,
  addNotification,
  fetchAccountLocalRestrictions,
  dismissAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadDriverLicenseContainer);



// WEBPACK FOOTER //
// ./src/components/UploadDriverLicense/index.js